// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_zvd","tabsBox":"styles_tabsBox__3vID6","createButton":"styles_createButton__1rvmv"};